import { Component, OnInit } from '@angular/core';
import { Product } from '../../../../classes/Product';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../services/login.service';
import { ImagesService } from '../../../services/images.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';
import * as $ from 'jquery';

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.css']
})
export class EditProductComponent implements OnInit {
    
  isSubmitButtonDisabled: boolean = false;
  id: number;
  contentVisible: boolean = false;
  editProduct: Product = new Product( );

  hasNotes: boolean = false;
  notes: any[] = [];
  isRequiredNotesField: boolean = true;
  isNotesWasEdited: boolean = false;

  manufacturers = [];

  availableRoles: string[] = [ 'admin', 'sales', 'manager' ];
  isAvailable: boolean = true;

  specsName: string = '';

  linkedProduct: any = {};
  linkedProductPopupVisible: boolean = false;
  
  addLinkedProductButtonDisabled: boolean = false;

  // Lists for overlay
  productTypesList  = [];
  baseTypesList     = [];
  descriptionsList  = [];

  isProductFieldDisabled: boolean = true;

  // Control for overlay additional fields
  showAdditionalFields: boolean = false;

  // Filters for overlay
  filters: any = {
    available_entity: '',
    need_proposed: false,
    type:         '',
    entity:       '',
    productType:  '',
    baseType:     '',
    description:  '',
    excludeID:    []
  };

  productList: any[] = [];

  _productTypes: any[] = [];
  _baseTypes: any[] = [];

  _addNewProductType: boolean = false;
  _addNewBaseType: boolean = false;

  _newProductType: string = '';
  _newBaseType: string = '';

  // Additional info on overlay
  additionalOverlayFields = { };

  popupMinimized: boolean = false;
  

  previousUrl: string = '/products-list';

  SKUSearch: string = '';
  descriptionSearch: string = '';
  searchBySKU: boolean = true;

  selectParams: any = {

    existingOrProposed: {
      id: 'inputExistingOrProposed',
      isDisabled: true,
      isRequired: true,
      change: ( event ) => { 
        this.editProduct.existingOrProposed = event.value; 
        this.changeType( );
      },
      options: [ { text: '', value: '' } ]
    },

    manufacturer: {
      id: 'inputManufacturer',
      isDisabled: this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager',
      isRequired: this.editProduct.existingOrProposed == 'proposed',
      change: ( event ) => { 
        this.editProduct.manufacturer_id = event.value;
        this.changeManufacturerSelect( );
      },
      options: [ { text: '', value: '' } ]
    },

    productType: {
      id: 'selectProductType',
      isDisabled: !this._productTypes.length || !this.editProduct.manufacturer_id,
      isRequired: true,
      change: ( event ) => { 
        this.editProduct.productType = event.value; 
        this.editProduct.baseType = ''; 
        this.changeProductTypeSelect( );
      },
      options: [ { text: '', value: '' } ]
    },

    baseType: {
      id: 'selectBaseType',
      isDisabled: !this._baseTypes.length || !this.editProduct.manufacturer_id || !this.editProduct.productType,
      isRequired: true,
      change: ( event ) => { this.editProduct.baseType = event.value; },
      options: [ { text: '', value: '' } ]
    },


    overlayEntity: {
      id: 'inputLinkedProductProductType',
      isRequired: true,
      change: ( event ) => {
        this.linkedProduct.entity = event.value;
        this.changeLinkedProductProperty( 'entity', '' );
      },
      options: [ 
      { text: '', value: '' },
      { text: 'Lamp', value: 'bulb' },
      { text: 'Fixture', value: 'fixture' },
      { text: 'Accessory', value: 'accessory' },
      { text: 'Housing', value: 'housing' },
      ],
      search: false
    },


    overlayProductType: {
      id: 'inputLinkedProductProductType',
      isRequired: true,
      isDisabled: this.isProductFieldDisabled,
      change: ( event ) => {
        this.filters.productType = event.value;
        this.changeLinkedProductProperty( 'productType', event.value );
      },
      options: [ { text: '', value: '' } ]
    },


    overlayBaseType: {
      id: 'inputLinkedProductBaseType',
      isDisabled: this.isProductFieldDisabled,
      isRequired: true,
      change: ( event ) => {
        this.filters.baseType = event.value;
        this.changeLinkedProductProperty( 'baseType', event.value );
      },
      options: [ { text: '', value: '' } ]
    },


    overlayDescription: {
      id: 'inputLinkedProductDescription',
      isRequired: true,
      isDisabled: this.isProductFieldDisabled,
      change: ( event ) => {
        this.filters.description = event.value;
        this.setNewLinkedProductEntityID(  event.value );
        this.changeLinkedProductProperty( 'description', event.value );
      },
      options: [ { text: '', value: '' } ]
    }

  }

  constructor ( 
    private route: ActivatedRoute,
    private model: ModelService,
    private cropper: ImagesService,
    public global: GlobalService,
    private alerts: AlertsService,
    private sanitizer: DomSanitizer,
    private loginService: LoginService ) { 
    this.global.setDocumentTitle( 'Edit Product' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;

    this.previousUrl = this.global.productRefPageURL;

    this.selectParams.existingOrProposed.options.push( { text: 'Existing', value: 'existing' } );
    if ( this.loginService.userInfo.role != 'sales' && this.loginService.userInfo.role != 'manager' ) this.selectParams.existingOrProposed.options.push( { text: 'Proposed', value: 'proposed' } );

  }

  ngOnInit ( ) { 
    
    this.route.params.subscribe(params => {
      this.id = +params['id'];
      this.model.getManufacturersDataWithEntity( this.editProduct.entity, ( data ) => {
        this.manufacturers = data;
        this.selectParams.manufacturer.options = [ { text: '', value: '' } ];
        data.forEach( _mn => {
          this.selectParams.manufacturer.options.push( { text: _mn.name, value: _mn.id } );
        });
        this.model.getProductDataByID( this.id, ( product ) => {
          this.selectParams.manufacturer.isRequired = product.existingOrProposed == 'proposed';
          if ( ( this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager' ) && product.existingOrProposed != 'existing' ) {
            this.isAvailable = false;
            return;
          } else {
            this.contentVisible = true;
            product.notes = '';
            this.editProduct = product;
            if (product.specsPDF) {
              this.specsName = product.specsPDF.substring(product.specsPDF.lastIndexOf('/')+1);
            }
            this.editProduct.id = this.id;
            this.getProductsTypes( ( ) => { this.getBaseType( ); } );
          }
        });
        this.getNotes( );
      });
    });
  }

  getNotes ( ) {
    this.model.getNotes( 'product', this.id, ( notes ) => {
      this.notes = notes;
      this.hasNotes = notes.length != 0;
    });
  }

  addNote ( ) {
    this.model.addNote( 'product', this.id, this.editProduct.notes, ( response ) => {
      this.getNotes( );
      this.isRequiredNotesField = false;
      this.isNotesWasEdited = true;
    });
  }

  minimizePopup ( ) { 
    this.popupMinimized = !this.popupMinimized; 
    this.fixingBodyOverflow( );
  }

  showHistory ( ) { this.global.changeHPVisibility( true ); }

  changeSpecs ( $event ) {

    let file: any = $event.target.files[0];

    if ( !file ) return;

    this.global.showPreloader( );
    let formData = new FormData( );
    formData.append( 'pdf', file, file.fileName );
    this.model.uploadProductSpecs( formData, file.fileName, ( response ) => {
      if ( !response.error ) {
        this.editProduct.specsPDF = response.url;
        this.specsName = response.url.substring(response.url.lastIndexOf('/')+1);
      }
      else this.global.defaultErrorCallback( response.error );
      this.global.hidePreloader( );
    });
  }


  changeType ( ) {
    if ( this.editProduct.existingOrProposed == 'existing' ) {
      this.editProduct.sellPrice        = 0.01;
      this.editProduct.buyPrice         = 0.02;
      this.editProduct.markup           = 100;
    } else if ( this.editProduct.existingOrProposed == 'proposed' ) {
      if ( this.editProduct.sellPrice == 0 ) delete this.editProduct.sellPrice;
      if ( this.editProduct.buyPrice == 0 ) delete this.editProduct.buyPrice;
      if ( this.editProduct.markup == 0 ) delete this.editProduct.markup;
    }
    this.selectParams.manufacturer.isRequired = this.editProduct.existingOrProposed == 'proposed';
  }

  deleteImage ( inputFile, public_id ) {
    inputFile.value = '';
    this.model.deleteProductAttachment( this.editProduct.id, ( ) => {
      this.cropper.destroyImage( public_id, ( ) => {
          this.editProduct.attachment = '';
          this.editProduct.attachment_public_id = '';
      });
    });
  }
  
  getManufacturersData ( ) {
    this.model.getManufacturersDataWithEntity( this.editProduct.entity, ( data ) => {
      this.global.hidePreloader( ).subscribe( );
      this.manufacturers = data;
      this.selectParams.manufacturer.options = [ { text: '', value: '' } ];
      data.forEach( _mn => {
        this.selectParams.manufacturer.options.push( {text: _mn.name, value: _mn.id} );
      });
    });
  }

  successCallback ( ) {
    // let _redirect = '/products-list';

    // if ( this.global.prevRoute == '/product-detail/'+this.id ) _redirect = this.global.prevRoute;

    this.global.defaultSuccessMessage({ 
      html: 'Product information has been updated successfully', 
      redirect: this.previousUrl
    });
  }


  errorCallback ( message?: string ) {
    let data = {
      messageType: 'error',
      message: message || 'We got some error here...',
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.isSubmitButtonDisabled = false;
  }


  changeManufacturerSelect ( ) { 
    this.changeProductMarkup( ( ) => {
      this.getProductsTypes( );
    });
  }

  changeProductTypeCheckbox ( ) {
    if ( this._addNewProductType ) this._addNewBaseType = true;
    this.getBaseType( );
  }

  changeProductTypeSelect ( ) {
    this.getBaseType( ( ) => {
      if ( this.editProduct.productType && this._baseTypes.length ) this._addNewBaseType = false;
    });
  }

  getBaseType ( cb? ) {
    this.model.getBaseTypeData( this.editProduct.manufacturer_id, this.editProduct.productType, this.editProduct.entity, ( baseTypes ) => {
      this._baseTypes = baseTypes;
      this.selectParams.baseType.options = [ { text: '', value: '' } ];
      baseTypes.forEach( _bt => {
        this.selectParams.baseType.options.push( {text: _bt, value: _bt} );
      });
      if ( !baseTypes.length ) this._addNewBaseType = true;
      if ( cb ) cb( )
    });
  }

  getProductsTypes ( cb? ) {
    this.model.getProductsTypeData( this.editProduct.manufacturer_id, this.editProduct.entity, ( productTypes ) => {
      this._productTypes = productTypes;
      this.selectParams.productType.options = [ { text: '', value: '' } ];
      if ( !productTypes.length ) {
        this._addNewProductType = true;
        this._addNewBaseType = true;
      } else {
        productTypes.forEach( _pt => {
          this.selectParams.productType.options.push( { text: _pt, value: _pt } );
        });
        this._addNewProductType = false;
        this._addNewBaseType = false;
      }
      if ( cb ) cb( )
    });
  }

  changeProductMarkup ( cb? ) { 
    if ( !this.editProduct.manufacturer_id ) return;
    this.model.getManufacturerDataByID ( this.editProduct.manufacturer_id, ( manufacturer ) => {
      this.editProduct.markup = manufacturer.markup; 
      this.calculateSellPrice( );
      if ( cb ) cb( )
    });
  }

  calculateSellPrice ( ) {
    if ( this.editProduct.buyPrice ) {
      if ( this.editProduct.markup ) {
        this.editProduct.sellPrice = ( +this.editProduct.buyPrice + ( this.editProduct.buyPrice * this.editProduct.markup / 100 ) ).toFixed( 2 ).toString( );
      } else {
        this.editProduct.sellPrice = +this.editProduct.buyPrice;
      }
    }
  }

  calculateBuyPrice ( ) {
    if ( this.editProduct.sellPrice ) {
      if ( this.editProduct.markup ) {
        // this.editProduct.sellPrice = +this.editProduct.buyPrice + ( this.editProduct.buyPrice * this.editProduct.markup / 100 );
        this.editProduct.buyPrice = ( ( +this.editProduct.sellPrice ) / ( 1 + this.editProduct.markup / 100 ) ).toFixed( 2 ).toString( );
      } else {
        this.editProduct.buyPrice = +this.editProduct.sellPrice;
      }
    }
  }
  
  calculateMarkup ( ) {
    if ( this.editProduct.sellPrice ) {
      if ( this.editProduct.buyPrice ) {
         this.editProduct.markup = ( 100 * ( ( +this.editProduct.sellPrice - +this.editProduct.buyPrice ) / +this.editProduct.buyPrice ) ).toFixed( 1 ).toString( );
      }
    }
  }

  calculateBothPrice ( ) {
    this.calculateSellPrice( );
    this.calculateBuyPrice( );
  }

  calculateTotalWatts ( ) {
    if ( this.editProduct.entity == 'housing' ) return;
    if ( this.editProduct.wattsPerLamp ) {
      if ( this.editProduct.lampsPerProduct ) {
        this.editProduct.watts = +this.editProduct.wattsPerLamp * +this.editProduct.lampsPerProduct;
      } else {
        this.editProduct.watts = +this.editProduct.wattsPerLamp;
      }
    } else {
        this.editProduct.watts = 0;
    }
  }

  setProductType ( productType ) { 
    this.editProduct.entity = productType; 
    this.getManufacturersData( );
  }

  submitForm ( ) {

    this.isSubmitButtonDisabled = true;

    this.editProduct.basicSpec = $( '#inputBasicSpecs' ).html( );

    if ( this._addNewProductType ) this.editProduct.productType = this._newProductType;
    if ( this._addNewBaseType ) this.editProduct.baseType = this._newBaseType;

    if ( +this.editProduct.sellPrice < +this.editProduct.buyPrice ) {
      this.errorCallback( 'Sell price can not be less then buy price' );
      this.global.defaultErrorCallback( 'Sell price can not be less then buy price' );
      $( '#inputSellPrice' ).focus( );
      return false;
    }

    let _basicSpecs;
    _basicSpecs = $.trim( $( '#inputBasicSpecs' ).text( ) );

    if ( _basicSpecs == "" ) {
      this.global.defaultErrorCallback( 'Field "Basic specs" cannot be empty!', false );
      this.isSubmitButtonDisabled = false;
      return false;
    }

    if ( this.editProduct.entity == 'fixture' ) this.editProduct.baseType = 'N/A';

    this.model.editProduct( this.editProduct, ( response ) => {
      let _answer;
      let _active = true;
      let _existsErrorMessage = 'This product already exists';
      
      _answer = response.json( ).answer;
      
      if ( _answer == 'success' ) this.successCallback( );
      else {
        if ( _answer == 'exists' ) {
          _active = response.json( ).active;
          if ( _active ) {
            _existsErrorMessage = 'Product with this Product Type + Description already exists in the database: Active';
            if ( this.editProduct.existingOrProposed == 'proposed' ) _existsErrorMessage = 'Product with this Product Type + Description + Manufacturer already exists in the database: Active';
          } else {
            _existsErrorMessage = 'Product with this Product Type + Description already exists in the database: Inactive';
            if ( this.editProduct.existingOrProposed == 'proposed' ) _existsErrorMessage = 'Product with this Product Type + Description + Manufacturer already exists in the database: Inactive';
          }
          this.errorCallback( _existsErrorMessage );
          this.global.defaultErrorCallback( _existsErrorMessage );
        } else {
          this.errorCallback( _answer );
          this.global.defaultErrorCallback( _answer, false );
        }
      }
    });
    return false;
  }
  
  cancelSubmit ( ) {
    // let _redirect = '/products-list';
    // if ( this.global.prevRoute == '/product-detail/'+this.id ) _redirect = this.global.prevRoute;
    this.global.redirect( this.previousUrl );
  }





  ///////////////////////////////////////
  ///////////////////////////////////////
  //             
  //             Overlay
  //             
  ///////////////////////////////////////
  ///////////////////////////////////////


  removeLinkedProduct ( ind:number ) {

    let _answer;
    let data = {
      message: "Warning! Are you sure you want to remove this selection?",
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    };

    this.global.confirmMessage( data, ( ) => {
      this.editProduct.linkedProducts.splice( ind, 1 );
    });

  }

  showLinkedProductProductOverlay ( ) {

    this.linkedProduct = {};
    this.linkedProduct.type = 'proposed';

    this.linkedProductPopupVisible = true;
    this.fixingBodyOverflow( );
  }


  saveLinkedProduct ( ) {

    // Code to save it when we press "Save" on overlay
    
    this.editProduct.linkedProducts.push( this.linkedProduct );
    this.linkedProductPopupVisible = false;
    this.fixingBodyOverflow( );

  }

  getExcludeID ( entityID ) {

    let excludeID = [];

    this.editProduct.linkedProducts.forEach( ( product ) => {
      if ( excludeID.indexOf( product.entityID ) == -1 && product.entityID != entityID ) excludeID.push( product.entityID );
    });

    return excludeID;

  }

  addLinkedProduct ( ) {

    this.SKUSearch = '';
    this.descriptionSearch = '';
    this.searchBySKU = true;

    this.showAdditionalFields = false;
    this.isProductFieldDisabled = true;

    this.filters = {
      need_proposed: false,
      type:         'proposed',
      entity:       '',
      productType:  '',
      baseType:     '',
      description:  '',
      excludeID:    this.getExcludeID ( 0 )
    };

    // this.getProductsDataExcluding( ( products, _filters ) => {
      // this.filters.need_proposed = _filters.need_proposed;
      this.showLinkedProductProductOverlay ( );
    // });

    return false;
  }


  changeLinkedProductProperty ( _type, _value, cb? ) {
    let _entity = this.linkedProduct.entity;
    let existInLinked = false;
    if ( _entity ) this.isProductFieldDisabled = false;
    else this.isProductFieldDisabled = true;
    this.filters.entity = _entity || '';

    if ( _type == 'search' ) {
      this.filters.search = _value;
      this.filters.searchDescription = '';
    }
    if ( _type == 'searchDescription' ) {
      this.filters.search = '';
      this.filters.searchDescription = _value;
      _type = 'search';
    }

    if ( _type == 'entity' ) {
      this.filters.productType  = '';
      this.filters.baseType     = '';
      this.filters.description  = '';
    }
    if ( _type == 'productType'  ) {
      if ( _value && _entity == 'fixture' ) {
        this.filters.baseType = 'N/A';
        _type = 'baseType';
      } else {
        this.filters.baseType     = '';
        this.filters.description  = '';
      }
    }
    if ( _type == 'baseType' ) {
      this.filters.description  = '';
    }

    this.filters.id = this.id;

    if ( _type != 'description' ) {
      this.model.getProductsDataExcluding( this.filters, _type, ( products, _filters ) => {
        if ( this.searchBySKU ) { 
          if ( _filters.description.length ) {
            if ( _filters.description[0].id == this.id ) {
              this.global.defaultErrorCallback( 'Original and Linked products are the same. This is not allowed.' );
              return;
            }

            this.editProduct.linkedProducts.forEach( ( product ) => {
              if ( product.entityID == _filters.description[0].id ) existInLinked = true;
            });


            if ( existInLinked ) {
              this.global.defaultErrorCallback( 'Product you are trying to link is already linked.' );
              return;
            }

            this.filters.description = _filters.description[0].id;
            this.filters.entity = _filters.description[0].entity;
            this.filters.productType = _filters.description[0].productType;
            this.filters.baseType = _filters.description[0].baseType;
            this.linkedProduct.entity = _filters.description[0].entity;
            this.linkedProduct.productType = _filters.description[0].productType;
            this.linkedProduct.baseType = _filters.description[0].baseType;
            this.productTypesList = [ _filters.description[0].productType ];
            this.baseTypesList = [ _filters.description[0].baseType ];
            this.descriptionsList = _filters.description;
            this.prepareProductTypeList( );
            this.prepareBaseTypeList( );
            this.prepareDescriptionsList( );
            this.setNewLinkedProductEntityID(  _filters.description[0].id );
            this.changeLinkedProductProperty( 'description', _filters.description[0].id, true );
          } else {
            this.filters.entity = '';
            this.filters.productType = '';
            this.filters.baseType = '';
            this.filters.description = '';
            this.linkedProduct.entity = '';
            this.linkedProduct.productType = '';
            this.linkedProduct.baseType = '';
            this.productTypesList = [ ];
            this.baseTypesList = [ ];
            this.descriptionsList = [ ];
            this.prepareProductTypeList( );
            this.prepareBaseTypeList( );
            this.prepareDescriptionsList( );
            this.changeLinkedProductProperty( 'description', '', true );
            this.setNewLinkedProductEntityID(  '' );
            if (this.SKUSearch) {
              this.global.defaultErrorCallback( 'Product with SKU "'+this.SKUSearch+'" is not available' );
            }
            if (this.descriptionSearch) {
              this.global.defaultErrorCallback( 'Product with description "'+this.descriptionSearch+'" is not available' );
            }
          }
          return;
        }

        this.productList = products;
        this.productTypesList = _filters.productType;
        this.baseTypesList = _filters.baseType;
        this.descriptionsList = _filters.description;
        this.prepareProductTypeList( );
        this.prepareBaseTypeList( );
        this.prepareDescriptionsList( );
        if ( this.global.isFunction( cb ) ) cb( );
      }, 'linkedProduct');
    }
  }

  fillLinkedProductAdditionalInfo ( product ) {

    this.showAdditionalFields = true;
    this.additionalOverlayFields = {};
    this.additionalOverlayFields['description'] = product.description;
    this.additionalOverlayFields['SKU'] = product.SKU;
    this.additionalOverlayFields['entity'] = product.entity;
    this.additionalOverlayFields['attachment'] = product.attachment;
    this.additionalOverlayFields['sellPrice'] = '$'+product.sellPrice;

    if ( product.entity == 'fixture' || product.entity == 'bulb' ) {
      this.additionalOverlayFields['watts'] = product.watts;
      this.additionalOverlayFields['life'] = product.life;
    }

    if ( product.entity == 'fixture' ) {
      this.additionalOverlayFields['wattsPerLamp'] = product.wattsPerLamp;
      this.additionalOverlayFields['lampsPerProduct'] = product.lampsPerProduct;
    }

    if ( product.entity == 'housing' ) {
      this.additionalOverlayFields['lampsPerProduct'] = product.lampsPerProduct;
    }

    this.additionalOverlayFields['manufacturer'] = product.manufacturer_name;
  }


  setNewLinkedProductEntityID ( entityID ) {
    this.linkedProduct.entityID = entityID;
    if ( entityID == '' ) return;
    this.model.getProductDataByID( entityID, ( product ) => {
      this.linkedProduct.description = product.description;
      this.linkedProduct.manufacturer = product.manufacturer_name;
      this.linkedProduct.productType = product.productType;
      this.linkedProduct.baseType = product.baseType;
      this.linkedProduct.SKU = product.SKU;

      if ( product.specsPDF ) this.linkedProduct['specsPDF'] = product.specsPDF;
      else this.linkedProduct['specsPDF'] = '';
      if ( product.video ) this.linkedProduct['video'] = this.sanitizer.bypassSecurityTrustResourceUrl( product.video.toString( ).replace( 'watch?v=', 'embed/' ) );
      else this.linkedProduct['video'] = '';
      
      this.fillLinkedProductAdditionalInfo( product );
    });
  }

  getProductsDataExcluding ( cb ) {
    
    this.model.getProductsDataExcluding( this.filters, '', ( products, _filters ) => {
      this.productList = products;
      this.productTypesList = _filters.productType;
      this.baseTypesList = _filters.baseType;
      this.descriptionsList = _filters.description;
      this.prepareProductTypeList( );
      this.prepareBaseTypeList( );
      this.prepareDescriptionsList( );
      cb( products, _filters );
    }, 'linkedProduct' );
  }

  cancelNewLinkedProduct ( ) {
    this.linkedProductPopupVisible = false;
    this.fixingBodyOverflow( );
  }


  prepareProductTypeList ( ) {

    this.selectParams.overlayProductType.options = [{ value: '', text: '' }];

    this.productTypesList.forEach( _pt => {
      this.selectParams.overlayProductType.options.push( { value: _pt, text: _pt } );
    });
  }

  prepareBaseTypeList ( ) {
    
    this.selectParams.overlayBaseType.options = [{ value: '', text: '' }];

    this.baseTypesList.forEach( _bt => {
      this.selectParams.overlayBaseType.options.push( { value: _bt, text: _bt } );
    });
  }

  prepareDescriptionsList ( ) {

    let _SKU = '';

    this.selectParams.overlayDescription.options = [{ value: '', text: '' }];
    this.descriptionsList.forEach( _ds => {
      _SKU = _ds.SKU || 'N/A';
      this.selectParams.overlayDescription.options.push( { value: _ds.id, text: '$'+_ds.sellPrice+' — '+_ds.manufacturer+' — '+_ds.description, title: _SKU } );
    });
  }

  fixingBodyOverflow ( ) { this.global.fixBodyOverflow( this.linkedProductPopupVisible == true && this.popupMinimized == false ); }

  searchSKU ( $event ) {

    this.SKUSearch = $event.value;
    this.changeLinkedProductProperty( 'search', this.SKUSearch );

  }

  searchDescription ( $event ) {

    this.descriptionSearch = $event.value;
    this.changeLinkedProductProperty( 'searchDescription', this.descriptionSearch );

  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/products/edit-product/edit-product.component.ts